import { useSelector } from "react-redux";
import { selectJobDetails } from "../redux/slices/jobDetailsSlice";

/**
 * Custom hook to check if job details exist in Redux before fetching
 * This prevents redundant API calls by checking jobDetailsSlice first
 * 
 * @param {string} section - The section name in jobDetailsSlice (e.g., 'generalProject', 'pumps')
 * @param {number} zone - Optional zone number to check for zone-specific data
 * @returns {Object} - { hasData: boolean, data: array }
 */
const useJobDetailsCheck = (section, zone = null) => {
  const jobDetails = useSelector(selectJobDetails);
  
  if (!section || !jobDetails[section]) {
    return { hasData: false, data: [] };
  }

  const sectionData = jobDetails[section];
  
  // If no zone specified, just check if section has any data
  if (zone === null) {
    return { 
      hasData: Array.isArray(sectionData) && sectionData.length > 0, 
      data: sectionData 
    };
  }

  // If zone specified, check for zone-specific data
  const zoneData = sectionData.filter(item => item.Zone === zone);
  return { 
    hasData: zoneData.length > 0, 
    data: zoneData 
  };
};

export default useJobDetailsCheck;
